import "./Contact.css";
import { MdEmail } from "react-icons/md";
import { FaFacebookMessenger, FaWhatsapp } from "react-icons/fa";
import React, { useRef } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ps4ykz5",
        "template_rj38ddr",
        form.current,
        "1g8n4Wk0w21f_CV7p"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    //reset fields
    e.target.reset();
  };

  return (
    <section id="contact">
      {/* <h5>Get In Touch</h5> */}
      <h1>Contact Me</h1>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>kmuyesu@gmail.com</h5>
            <a href="mailto:kmuyesu@gmail.com" target="_blank" rel="noreferrer">
              Send an Email
            </a>
          </article>

          <article className="contact__option">
            <FaWhatsapp className="contact__option-icon" />
            <h4>WhatsApp</h4>
            <a
              href="https://api.whatsapp.com/send?phone=254717023695"
              target="_blank"
              rel="noreferrer"
            >
              Send a Text
            </a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="10"
            placeholder="Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
